export default "__VITE_ASSET__DlcNbMvR__"